import {
  InAppBrowser,
  InAppBrowserOptions,
  InAppBrowserEvent,
} from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Component, Input, OnInit } from '@angular/core';
import {
  LoadingController,
  ModalController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import {
  ClubMembership,
  CompetitionData,
  CompetitionFeeApplicable,
  PaymentGatewayInfo,
  PlayerClubAccount,
  PlayerInfo,
  PremiumFeaturePrice,
  TeeTimeBookingOptions,
} from 'src/data/mygolf.data';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import * as global from 'src/globals';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { PlayerService } from 'src/providers/player-service/player-service';
import { sha256 } from 'js-sha256';
import { CustomSha1 } from 'src/custom/sha1';
import { Router } from '@angular/router';

export interface Ipay88Details {
  merchantCode?: string;
  merchantKey?: string;
}

@Component({
  selector: 'app-competition-payment-selection',
  templateUrl: './competition-payment-selection.page.html',
  styleUrls: ['./competition-payment-selection.page.scss'],
})
export class CompetitionPaymentSelectionPage implements OnInit {
  playerClubAccount: PlayerClubAccount;
  walletBalance: number = 0;
  crdBalancePlayers: number = 0;
  facilityBookingDetail: any;
  paymentGatewayList: Array<PaymentGatewayInfo>;
  grpPayOnline: boolean = true;
  grpChargeToAccount: boolean = false;
  grpEWallet: boolean = false;
  grpClubWallet: boolean = false;
  appAttribute: any;
  showConsoleLog: boolean = false;
  enablePaymentTimer: boolean = false;
  showRecalculate: boolean = false;
  sandboxPayment: boolean = false;
  paymentTimerDuration: number = 5;
  selectPaymentMethod: string = 'online';
  paymentAmount: number = 0;
  paymentMode: boolean = false;
  paymentBackendURL: string;
  paymentRedirectURL: string;
  paymentCallbackURL: string;
  paymentInternalURL: string;
  paymentSignAlgo: string;
  paymentPageURL: string;
  goToPaymentURL: string;
  pgDescription: string;
  private ipay88Details: Ipay88Details;
  @Input() playerInfo: PlayerInfo & any;
  paymentStatus: string = 'Pending';
  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };
  paymentFailed: boolean = false;
  paymentDateTime: any = null;
  localBill: number;
  @Input() compData: CompetitionData;
  @Input() competitionFeeApplicable: CompetitionFeeApplicable;
  @Input() compPlayerId: number;
  @Input() playerId: number;
  @Input() clubPayment: boolean = false;
  @Input() disableCTA: boolean = false; //true;
  @Input() disableClubCredit: boolean = false; //true;
  @Input() disableWallet: boolean = true; //true;
  constructor(
    private modalCtl: ModalController,
    private navParams: NavParams,
    private paymentService: PaymentService,
    private flightService: ClubFlightService,
    private mg2uUtil: mygolfUtils,
    private platform: Platform,
    private toastCtl: ToastController,
    private sessionActions: SessionActions,
    private loadingCtrl: LoadingController,
    private playerService: PlayerService,
    private sessionDataService: SessionDataService,
    private iab: InAppBrowser,
    private sha1: CustomSha1,
    private router: Router
  ) {
    this.facilityBookingDetail = this.navParams.get('facilityBookingDetail');

    let _mygolfServerHost = global.MygolfServerHost;
    if (_mygolfServerHost)
      this.paymentBackendURL = 'http://' + _mygolfServerHost + '/rest/payment/ipay88/backend';
    else this.paymentBackendURL = 'http://devlet.mygolf2u.com/rest/payment/ipay88/backend';
    if (_mygolfServerHost === 'devlet.mygolf2u.com')
      this.paymentRedirectURL = 'http://dev-play.mygolf2u.com/payment_redirect.html';
    else if (_mygolfServerHost === 'azulet.mygolf2u.com')
      this.paymentRedirectURL = 'http://azu-play.mygolf2u.com/payment_redirect.html';

    if (_mygolfServerHost === 'devlet.mygolf2u.com') this.goToPaymentURL = 'dev-play';
    else if (_mygolfServerHost === 'azulet.mygolf2u.com') this.goToPaymentURL = 'azu-play';
  }

  async ngOnInit() {
    // console.debug(
    //   ' init comp player id - data',
    //   this.compPlayerId,
    //   this.compData,
    //   this.playerInfo,
    //   this.modalCtl,
    //   this.router.getCurrentNavigation()
    // );
    // await this.getGamePlayersInfo(this.playerId);

    // this.modalCtl?.getTop()?.then((result: any) => {
    //   console.debug(' init comp player id - data [0]', result);
    // });

    // if (!this.compPlayerId || !this.playerInfo?.playerId || !this.playerInfo?.player?.playerId) {
    //   MessageDisplayUtil.showErrorToast(
    //     "We couldn't find your competition registration details. This might be due to a connection issue. Please check your internet connection and try again.",
    //     this.platform,
    //     this.toastCtl,
    //     5000,
    //     'bottom'
    //   );
    //   this.backRouting();
    //   return;
    // }

    this.checkClubBookingOption();
    // if(!this.compPlayerId) {
    //   this.compPlayerId = this.compData?.players?.filter((cp: any) => {
    //     return cp?.player?.id === this.playerInfo?.playerId;
    //   })[0]?.id
    // }
  }

  ionViewWillEnter() {
    this.getGamePlayersInfo(this.playerId);
    if (this.compData) {
      this.getPaymentGateway(
        this.compData?.organizer?.country?.id || this.compData?.club?.address?.countryData?.id
      );
      this.paymentAmount = this.competitionFeeApplicable?.applicableFee;

      this.getClubMembership(this.playerId)
        .then((data: any) => {
          console.debug('get single membership promise : ', data);
          if (data.status === 'success') {
            if (
              data.clubMembership &&
              data.clubMembership.status.toLowerCase().includes('active') &&
              this.bookingOptions?.chargeToAccountEnabled
            )
              this.getPlayerClubAccount(
                this.playerId,
                this.compData?.club?.id || this.compData?.club?.clubId
              );
          }
        })
        .catch(data => {});

      try {
        this.flightService
          .getPlayerClubCredits(
            this.playerId,
            this.compData?.club?.id || this.compData?.club?.clubId
          )
          .subscribe(data => {
            if (data) {
              this.crdBalancePlayers = data.balance;
              if (data.walletBalance) this.walletBalance = data.walletBalance;
            }
          });
      } catch (err) {}
      this.checkClubBookingOption();
    }
    // if (this.facilityBookingDetail) {
    //   let countryId = this.facilityBookingDetail?.clubLite?.countryId;
    //   let clubId = this.facilityBookingDetail?.clubLite?.id;
    //   let playerId = this.facilityBookingDetail?.playerLite?.id;

    //   let balance =
    //     ((this.facilityBookingDetail.amountPayable -
    //       this.facilityBookingDetail.amountPaid +
    //       this.facilityBookingDetail.refundAmount) *
    //       100) /
    //     100;

    //   this.paymentAmount = balance;
    //   this.getPaymentGateway(countryId);
    //   this.getGamePlayersInfo(playerId);

    //   this.getClubMembership(playerId)
    //     .then((data: any) => {
    //       console.debug('get single membership promise : ', data);
    //       if (data.status === 'success') {
    //         if (
    //           data.clubMembership &&
    //           data.clubMembership.status.toLowerCase().includes('active')
    //         )
    //           this.getPlayerClubAccount(playerId, clubId);
    //       }
    //     })
    //     .catch((data) => {});

    //   try {
    //     this.flightService
    //       .getPlayerClubCredits(playerId, clubId)
    //       .subscribe((data) => {
    //         if (data) {
    //           this.crdBalancePlayers = data.balance;
    //           if (data.walletBalance) this.walletBalance = data.walletBalance;
    //         }
    //       });
    //   } catch (err) {}
    // }
    this.getAppAttribute();
    this.getPaymentSelectionAttribute();
    this.getAppAttributeForWallet();
  }

  getGamePlayersInfo(playerId) {
    this.playerService.getPlayerInfo(playerId).subscribe((playerInfo: PlayerInfo) => {
      if (playerInfo) {
        this.playerInfo = playerInfo;
      }
      console.log(this.playerInfo, 'this.playerInfo');
    });
  }

  getClubMembership(playerId) {
    return new Promise((resolve, reject) => {
      let _playerId = playerId;
      let _clubId = this.compData?.club?.id || this.compData?.club?.clubId;
      let _params = {
        playerId: _playerId,
      };
      this.flightService
        .getPlayerMemberships(_playerId)
        // this.flightService.getFilteredClubMemberships(_clubId, _params)
        .subscribe(
          async (data: Array<ClubMembership>) => {
            console.debug('get single membership : ', data, _clubId);
            if (data) {
              let _cm = data.filter((cm: ClubMembership) => {
                return cm.club && cm.club.clubId === _clubId;
              });
              console.debug('get single membership : ', _cm);
              if (_cm && _cm.length > 0) {
                resolve({
                  status: 'success',
                  message: 'has membership',
                  clubMembership: _cm[0],
                });
              } else {
                reject({
                  status: 'failed',
                  message: 'failed to get membership',
                  clubMembership: null,
                });
              }
            } else {
              reject({
                status: 'failed',
                message: 'failed to get membership',
                clubMembership: null,
              });
            }
          },
          error => {
            reject({
              status: 'failed',
              message: 'failed to get membership',
              clubMembership: null,
            });
          }
        );
    });
  }

  playerMaxChargeableAmount: number;
  getPlayerClubAccount(playerId, clubId) {
    let _clubId = clubId;
    let _playerId = playerId;
    let _params;
    _params = {
      clubId: _clubId,
      playerId: _playerId,
    };
    this.flightService.getPlayerClubAccount(_params).subscribe(
      data => {
        if (data) {
          this.playerClubAccount = data;

          this.getPlayerClubBalancePromise(playerId, clubId)
            .then((data: any) => {
              if (data && data.status === 'success') {
                this.playerMaxChargeableAmount = data.amount;
              } else this.playerMaxChargeableAmount = 0;
            })
            .catch(data => {});
        }
      },
      error => {
        let _error = error.json();
        let _msg = _error.errorMessage;
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        return false;
      }
    );
  }

  getPlayerClubBalancePromise(playerId, clubId) {
    let _params;
    let _clubId = clubId;
    let _playerId = playerId;
    _params = {
      clubId: _clubId,
      playerId: _playerId,
    };
    return new Promise((resolve, reject) => {
      if (this.playerClubAccount) {
        this.flightService.getPlayerMaxChargeableAmount(_params).subscribe(
          data => {
            if (data && data > 0) {
              resolve({
                status: 'success',
                message: 'sufficient balance',
                amount: data,
              });
            } else if (data === 0) {
              resolve({
                status: 'success',
                message: 'insufficient balance',
                amount: data,
              });
            } else if (data < 0) {
              reject({
                status: 'failed',
                message: 'insufficient balance',
                amount: data,
              });
            } else {
              reject({
                status: 'failed',
                message: 'no data',
                amount: data,
              });
            }
          },
          error => {
            reject({
              status: 'failed',
              message: 'no data',
              amount: 0,
            });
          }
        );
      } else {
        reject({
          status: 'failed',
          message: 'no data',
          amount: 0,
        });
      }
    });
  }

  backRouting() {
    this.modalCtl.dismiss();
  }

  getPaymentGateway(countryId?: string, paymentGatewayId?: string) {
    let _paymentGateway;
    let _countryId = countryId ? countryId : null;
    this.paymentService
      .getPaymentGateway(_countryId, _paymentGateway)
      .subscribe((pgList: Array<PaymentGatewayInfo>) => {
        if (pgList && pgList.length > 0) this.paymentGatewayList = pgList;
      });
  }

  getCompDetails(attribute?: string) {
    if (!attribute) return;
    if (!this.compData) return;
    if (!this.competitionFeeApplicable) return;
    // let _amountChargable = this.competitionFeeApplicable?.applicableFee;
    let _balance = Number(
      ((this.competitionFeeApplicable?.applicableFee -
        this.competitionFeeApplicable?.paymentAmount) *
        100) /
        100
    );
    switch (attribute) {
      case 'currency':
        return this.competitionFeeApplicable?.currency || this.compData?.currency?.symbol;
      case 'price':
        return this.competitionFeeApplicable?.applicableFee;
      case 'status':
        return this.competitionFeeApplicable?.paymentStatus;
      case 'balance':
        return _balance;
    }
  }

  getOrderDetails(attribute?: string) {
    let _statusText = '';
    let _amountChargable: number = 0;

    if (!this.facilityBookingDetail) return;

    switch (attribute) {
      case 'reference':
        return this.facilityBookingDetail.orderNumber;
      case 'price':
        return this.facilityBookingDetail.amountPayable;
      case 'currency':
        if (!this.facilityBookingDetail.clubLite) return;
        return this.facilityBookingDetail.clubLite.currencySymbol;
      case 'status':
        return this.facilityBookingDetail.status;
      case 'orderDate':
        return moment(this.facilityBookingDetail.orderDate, 'YYYY-MM-DD').format(
          "dddd, DD MMMM 'YY"
        );
      case 'customerName':
        return this.facilityBookingDetail.customerName;
      case 'taxAmount':
        return this.facilityBookingDetail.taxAmount;
      case 'paymentStatus':
        return this.facilityBookingDetail.paymentStatus;
      case 'amountPayable':
        return this.facilityBookingDetail.amountPayable;
      case 'orderAmount':
        return this.facilityBookingDetail.orderAmount;
      case 'discountGiven':
        return this.facilityBookingDetail.discountGiven;
      case 'refundAmount':
        return this.facilityBookingDetail.refundAmount;
      case 'roundingAdj':
        return this.facilityBookingDetail.roundingAdj;
      case 'taxProfile':
        return this.getTaxProfileAmount(this.facilityBookingDetail.taxProfile);
      case 'taxProfileWithName':
        if (!this.facilityBookingDetail.taxProfile) return '-';
        return (
          this.facilityBookingDetail.taxProfile.name +
          ' @ ' +
          this.getTaxProfileAmount(this.facilityBookingDetail.taxProfile)
        );
      case 'invoiceNumber':
        if (!this.facilityBookingDetail.invoiceNumber) return;
        return this.facilityBookingDetail.invoiceNumber;
      case 'balance':
        return Number(
          ((this.facilityBookingDetail.amountPayable -
            this.facilityBookingDetail.amountPaid +
            this.facilityBookingDetail.refundAmount) *
            100) /
            100
        );
      case 'amountPaid':
        return this.facilityBookingDetail.amountPaid;
    }
  }

  getTaxProfileAmount(profile) {
    if (!profile) return;
    // let _taxAmount = 0;
    let _taxAmountText = '';
    if (profile.taxAmountType === 'Absolute')
      _taxAmountText = 'Fixed amount of ' + profile.taxAmount;
    else if (profile.taxAmountType === 'Percentage') _taxAmountText = profile.taxAmount + '%';
    else if (profile.taxAmountType === 'Package') _taxAmountText = 'Up to ' + profile.taxAmount;
    return _taxAmountText;
  }

  togglePanel(panel: number) {
    if (panel === 1) {
      this.grpPayOnline = true;
      this.grpChargeToAccount = false;
      this.grpEWallet = false;
      this.grpClubWallet = false;
    } else if (panel === 2) {
      this.grpPayOnline = false;
      this.grpChargeToAccount = true;
      this.grpEWallet = false;
      this.grpClubWallet = false;
    } else if (panel === 3) {
      this.grpPayOnline = false;
      this.grpChargeToAccount = false;
      this.grpEWallet = true;
      this.grpClubWallet = false;
      // this.setValue(1);
      // this.getAppAttribute();
    } else if (panel === 4) {
      this.grpPayOnline = false;
      this.grpChargeToAccount = false;
      this.grpEWallet = false;
      this.grpClubWallet = true;
    }
  }

  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter(d => {
            return d.page === 'bookingDetails';
          })
          .map(d => {
            this.appAttribute = d;
          });

        if (this.appAttribute) {
          if (this.appAttribute.showConsoleLog)
            this.showConsoleLog = this.appAttribute.showConsoleLog;
          if (this.appAttribute.enablePaymentTimer)
            this.enablePaymentTimer = this.appAttribute.enablePaymentTimer;
          if (this.appAttribute.showRecalculate)
            this.showRecalculate = this.appAttribute.showRecalculate;
          if (this.appAttribute.paymentTimerDuration)
            this.paymentTimerDuration = this.appAttribute.paymentTimerDuration;
        }
      }
    });
  }

  appAttributeForWallet: any;
  getAppAttributeForWallet() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      console.log('[app attribute] : ', data);
      if (data) {
        data
          .filter(d => {
            return d.page === 'clubRefundRedeemHistory';
          })
          .map(d => {
            this.appAttributeForWallet = d;
          });
        console.log('[app attribute] : ', this.appAttributeForWallet);
      }
    });
  }

  paymentSelectionAttribute: any;
  allowPaymentSelection: boolean = false;
  getPaymentSelectionAttribute() {
    this.mg2uUtil
      .getAppAttribute()
      ?.filter(appAttr => {
        return appAttr.page === 'paymentSelection';
      })
      .map(appAttr => {
        this.paymentSelectionAttribute = appAttr;
        if (appAttr?.allowPaymentSelection) {
          this.allowPaymentSelection = appAttr.allowPaymentSelection;
          let _selected = appAttr.defaultPaymentGateways.filter(pg => {
            return pg.enable;
          });
          if (_selected?.length > 0) this.selectPaymentMethod = _selected[0].id;
        }
      });
  }

  getFilteredPaymentGatewayList() {
    let _filteredList = this.paymentGatewayList;
    if (
      this.allowPaymentSelection &&
      this.paymentSelectionAttribute?.defaultPaymentGateways?.length > 0
    ) {
      let _defaultGateways = this.paymentSelectionAttribute?.defaultPaymentGateways;
      _filteredList = this.paymentGatewayList.filter(pg => {
        return _defaultGateways.some(dg => {
          return dg.id === pg.id && dg.enable;
        });
      });
    }
    // console.debug("get filtered payment gateway list ", _filteredList, this.paymentGatewayList, this.paymentSelectionAttribute)
    return _filteredList;
  }

  onCheckDeposit() {
    let balance =
      ((this.facilityBookingDetail.amountPayable -
        this.facilityBookingDetail.amountPaid +
        this.facilityBookingDetail.refundAmount) *
        100) /
      100;

    if (this.paymentAmount > balance) {
      this.paymentAmount = balance;
    } else if (this.paymentAmount < 0) {
      this.paymentAmount = balance;
    }
  }

  isIOS() {
    return this.platform.is('ios') || this.platform.is('iphone') || this.platform.is('ipad');
  }

  async onPay() {
    if (!this.competitionFeeApplicable) return;
    if (this.paymentAmount <= 0) {
      MessageDisplayUtil.showMessageToast(
        'Total amount is less than 0',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    if (!this.grpPayOnline && !this.grpChargeToAccount && !this.grpEWallet && !this.grpClubWallet) {
      MessageDisplayUtil.showMessageToast(
        'Please select a payment method to proceed.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    if (this.grpChargeToAccount) {
      if (this.playerMaxChargeableAmount < this.paymentAmount) {
        MessageDisplayUtil.showErrorToast(
          'Insufficient balance to pay. Please choose other method. ',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return;
      }
    }

    if (this.grpClubWallet) {
      if (this.crdBalancePlayers < this.paymentAmount) {
        MessageDisplayUtil.showErrorToast(
          'Insufficient balance to pay. Please choose other method. ',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return;
      }
    }

    if (this.grpPayOnline) {
      let _title = 'Redirecting to payment page';
      let _message = '';
      if (this.selectPaymentMethod === 'chgacc')
        _message = 'This will charge to account. Do you want to proceed?';
      else if (this.isIOS())
        _message =
          'You are using iOS device, you may need to disable any content blocker first. This will bring up the payment system. Do you want to proceed?';
      else _message = 'This will bring up the payment system. Do you want to proceed?';

      let PriceDetailmodal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'priceDetails',
          msg: _message,
          header: _title,
        },
      });
      await PriceDetailmodal.present().then(() => {
        const height = this.platform.height() - 180;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      PriceDetailmodal.onDidDismiss().then(async (data: any) => {
        console.debug('on dismiss ', data);
        if (data && data?.data === 'confirm') {
          this.goPayNow();
        }
      });
    } else if (this.grpEWallet || this.grpClubWallet) {
      let _title = 'Redeem Credits';
      let _message = 'Total redeem amount is {amount}. Do you want to proceed?';

      if (this.appAttributeForWallet) {
        if (this.appAttributeForWallet.playerRedeemConfirmTitle)
          _title = this.appAttributeForWallet.playerRedeemConfirmTitle;
        if (this.appAttributeForWallet.playerRedeemConfirmMessage)
          _message = this.appAttributeForWallet.playerRedeemConfirmMessage;
      }

      let reAmount = /{amount}/gi;

      var ammt = 0;
      if (this.grpClubWallet) {
        var amt = this.paymentAmount;
        if (amt > this.crdBalancePlayers) {
          ammt = this.crdBalancePlayers;
        } else {
          ammt = amt;
        }
      } else if (this.grpEWallet) {
        var amt = this.paymentAmount;
        if (amt > this.walletBalance) {
          ammt = this.walletBalance;
        } else {
          ammt = amt;
        }
      }
      // this.getOrderDetails('currency')
      let _amount = this.getCompDetails('currency') + ' ' + ammt;
      _message = _message.replace(reAmount, _amount);

      let modal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'priceDetails',
          msg: _message,
          header: _title,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 180;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then(async (data: any) => {
        console.debug('on dismiss ', data);
        if (data && data?.data === 'confirm') {
          this.goRedeem();
        }
      });
    } else if (this.grpChargeToAccount) {
      let _title = 'Redirecting to payment page';
      let _message = '';
      // if (this.selectPaymentMethod === 'chgacc')
      //   _message = 'This will charge to account. Do you want to proceed?';
      // else
      if (this.isIOS())
        _message =
          'You are using iOS device, you may need to disable any content blocker first. This will bring up the payment system. Do you want to proceed?';
      else _message = 'This will charge to account. Do you want to proceed?';

      let modal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'priceDetails',
          msg: _message,
          header: _title,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 180;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then(async (data: any) => {
        console.debug('on dismiss ', data);
        if (data && data?.data === 'confirm') {
          let _amountToPay;
          if (this.playerClubAccount) {
            if (
              this.playerClubAccount.allowCredit &&
              this.playerClubAccount.creditLimitApplicable
            ) {
              if (this.paymentAmount > this.playerMaxChargeableAmount)
                _amountToPay = this.playerMaxChargeableAmount;
              else _amountToPay = this.paymentAmount;
            } else if (
              this.playerClubAccount.allowCredit &&
              !this.playerClubAccount.creditLimitApplicable
            ) {
              _amountToPay = this.paymentAmount;
            } else _amountToPay = this.paymentAmount;
          }

          let _playerId = this.playerInfo.playerId;
          let _params = {
            amount: _amountToPay,
            playerId: _playerId,
          };
          this.goRedeem();
        }
      });
    }
  }

  goRedeem() {
    let _bypassWallet: boolean = false;
    if (this.grpChargeToAccount) {
      _bypassWallet = true;
    } else {
      if (this.grpEWallet) _bypassWallet = false;
      else if (this.grpClubWallet) _bypassWallet = true;
    }
    var amount = 0;
    if (this.grpClubWallet) {
      var amt = this.paymentAmount;
      if (amt > this.crdBalancePlayers) {
        amount = this.crdBalancePlayers;
      } else {
        amount = amt;
      }
    } else if (this.grpEWallet) {
      var amt = this.paymentAmount;
      if (amt > this.walletBalance) {
        amount = this.walletBalance;
      } else {
        amount = amt;
      }
    }

    // let _description = 'Payment for Order ' + this.facilityBookingDetail?.id;
    let _description =
      'Payment for Competition ' + this.compData?.id + ' - Player ' + this.playerInfo?.playerId;

    let compId = this.compData?.id;
    let playerId = this.playerId;
    let _params = {
      bypassWallet: _bypassWallet,
      amount: amount,
      remarks: _description,
    };
    this.flightService
      .chargeToAccountCompFee(compId, playerId, this.paymentAmount)
      // .chargeToAccountOrder(clubId, _orderId, _params)
      .subscribe(
        (data: any) => {
          MessageDisplayUtil.showMessageToast(
            'Successfully redeemed credits.',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          this.backRouting();
        },
        error => {
          console.debug('charge error : ', error);
          let _msg = 'Something has happened, please try again or contact myGolf2u admin.';
          // if (error && error?.json()) {
          //   let _error = error.json();
          //   if (_error.errorMessage) _msg = _error.errorMessage;
          // } else {
          _msg = error;
          // }
          MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
        }
      );
  }

  async goPayNow() {
    // let _random = Math.floor(Math.random() * 3);
    // if (_random === 2) {
    //   this.compPlayerId = null;
    //   this.playerInfo = null;
    // }

    // if (!this.compPlayerId || !this.playerInfo?.playerId) {
    //   MessageDisplayUtil.showErrorToast(
    //     "We couldn't find your competition registration details. This might be due to a connection issue. Please check your internet connection and try again.",
    //     this.platform,
    //     this.toastCtl,
    //     5000,
    //     'bottom'
    //   );
    //   this.modalCtl.dismiss();
    //   return;
    // }
    this.sessionActions.setNeedRefresh(true);
    let _amountPay = Number(this.paymentAmount.toFixed(2));
    let _collectionId: string = 'q70lo0l_';

    let loder = await this.loadingCtrl.create({
      message: 'Redirecting to payment page...',
      showBackdrop: false,
      duration: 5000,
    });

    // let priceInfo = {
    //   country: this.facilityBookingDetail.clubLite.countryId,
    //   currency: this.facilityBookingDetail.clubLite.currencyId,
    //   endDate: moment('2020-06-30T00:00:00').toDate(),
    //   id: 2,
    //   price: _amountPay,
    //   pricingType: 'F',
    //   startDate: moment('2020-01-01T00:00:00').toDate(),
    // };
    let _description =
      'Payment for Competition ' + this.compData?.id + ' - Player ' + this.playerInfo?.playerId;

    let _paymentGateway = this.selectPaymentMethod.includes('ipay88') ? 'ipay88' : 'billplz';
    let _url =
      this.selectPaymentMethod === 'ipay88fpx'
        ? 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-fpx.html'
        : 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment.html';
    if (this.selectPaymentMethod === 'ipay88fpx')
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-fpx.html';
    else if (
      this.selectPaymentMethod !== 'ipay88fpx' &&
      (this.compData?.organizer?.country?.id === 'IDN' ||
        this.compData?.club?.address?.countryData?.id === 'IDN')
    ) {
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-id.html';
    } else {
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment.html';
    }

    let _signature;
    let _pgRegion;
    let _countryId;
    let _type;
    let _selPM;
    let paymentDetails: any;
    let paymentDetailsPage: any;
    if (_paymentGateway === 'ipay88' && this.selectPaymentMethod === 'ipay88fpx') {
      _selPM = 'ipay88-fpx';
    } else if (_paymentGateway === 'ipay88' && this.selectPaymentMethod !== 'ipay88fpx') {
      if (
        this.compData?.organizer?.country?.id === 'IDN' ||
        this.compData?.club?.address?.countryData?.id === 'IDN'
      ) {
        _selPM = 'ipay88-id';
      } else _selPM = 'ipay88';
    } else _selPM = 'billplz';

    if (this.paymentGatewayList)
      this.paymentGatewayList
        .filter((pg: PaymentGatewayInfo) => {
          return pg.type === _paymentGateway && pg.id === this.selectPaymentMethod;
        })
        .map(pg => {
          _pgRegion = pg.id;
          _countryId = pg.country_id;
          _type = pg.type;
          this.ipay88Details = {
            merchantCode: pg.merchant_code,
            merchantKey: pg.merchant_key,
          };
          this.paymentBackendURL = pg.callback_url;
          this.paymentRedirectURL = pg.redirect_url;
          this.paymentInternalURL = pg.internal_payment_url;
          this.paymentPageURL = pg.http_server + pg.payment_url;
          this.pgDescription = pg.description;
          if (pg.signature_algorithm && pg.signature_algorithm.length > 0)
            this.paymentSignAlgo = pg.signature_algorithm;
          if (
            pg.signature_algorithm &&
            pg.signature_algorithm.length > 0 &&
            (pg.signature_algorithm.toLowerCase() === 'sha-256' ||
              pg.signature_algorithm.toLowerCase() === 'sha-1')
          )
            this.paymentSignAlgo = this.paymentSignAlgo.replace('-', '');
          _url = this.paymentInternalURL ? this.paymentInternalURL : pg.internal_payment_url;
        });
    if (this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())) _amountPay = 10000;

    if (this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
      let _amount;
      if (
        _pgRegion.toLowerCase().includes('ipay88-id') &&
        !this.pgDescription.toLowerCase().includes('sandbox')
      )
        _amount = _amountPay * 100;
      else if (
        _pgRegion.toLowerCase().includes('ipay88-id') &&
        this.pgDescription.toLowerCase().includes('sandbox')
      )
        _amount = _amountPay;
      else if (
        _type.toLowerCase().includes('ipay88') &&
        _countryId.toLowerCase() === 'mys' &&
        !this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
      )
        _amount = _amountPay * 100;
      else if (
        _type.toLowerCase().includes('ipay88') &&
        _countryId.toLowerCase() === 'mys' &&
        this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
      ) {
        _amount = 100;
        this.sandboxPayment = true;
      } else _amount = _amountPay * 100;

      _amount = Number(_amount).toFixed(0);

      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount,
        email: this.playerInfo?.email,
        name: this.playerInfo?.playerName,
        mobile: this.playerInfo?.phone,
        description: _description,
        currency: this.competitionFeeApplicable?.currency || 'MYR',
        callback_url: this.paymentBackendURL,
        redirect_url: this.paymentRedirectURL,
        bill_type: 'competition_player',
        bill_type_id: this.compPlayerId,
        paid_by: this.playerInfo?.playerId || this.playerInfo?.player?.playerId,
        payer_type: 'R',
        payment_type: 'B',
        payment_gateway: _pgRegion,
      };
    } else if (this.selectPaymentMethod.toLowerCase().includes('billplz')) {
      let _amount = Number(_amountPay * 100).toFixed(0);
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount,
        email: this.playerInfo?.email,
        name: this.playerInfo?.playerName,
        mobile: this.playerInfo?.phone,
        description: _description,
        currency: this.competitionFeeApplicable?.currency || 'MYR',
        callback_url: this.paymentCallbackURL,
        redirect_url: this.paymentRedirectURL,
        bill_type: 'competition_player',
        bill_type_id: this.compPlayerId,
        paid_by: this.playerInfo?.playerId || this.playerInfo?.player?.playerId,
        payer_type: 'R',
        payment_type: 'B',
        payment_gateway: 'billplz',
      };
    } else {
      let _amount = Number(_amountPay * 100).toFixed(0);
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount,
        email: this.playerInfo?.email,
        name: this.playerInfo?.playerName,
        mobile: this.playerInfo?.phone,
        description: _description,
        currency: this.competitionFeeApplicable?.currency || 'MYR',
        callback_url: this.paymentCallbackURL,
        redirect_url: this.paymentRedirectURL,
        bill_type: 'competition_player',
        bill_type_id: this.compPlayerId,
        paid_by: this.playerInfo?.playerId || this.playerInfo?.player?.playerId,
        payer_type: 'R',
        payment_type: 'B',
        payment_gateway: this.selectPaymentMethod, // 'billplz',
      };
    }

    loder.present().then(() => {
      this.sessionDataService.getNeedRefresh().subscribe(result => {
        console.debug('result ', result);
      });
      this.paymentService.createBill(_collectionId, paymentDetails, _paymentGateway).subscribe(
        (data: any) => {
          loder.dismiss().then(
            () => {
              if (data.url && this.selectPaymentMethod.toLowerCase().includes('billplz')) {
                if (this.platform.is('capacitor')) {
                  this.openWithInAppBrowser(data.url, null, 'getBill', data);
                } else {
                  let win = window.open(data.url, '_system');
                  let winTick = setInterval(() => {
                    if (win && win.closed) {
                      clearInterval(winTick);
                      this.getBill(data.id, 'billplz');
                    }
                  }, 500);
                }
              } else if (data && this.selectPaymentMethod.toLowerCase().includes('ipay88')) {
                let _data = data;
                let _amount;
                if (_pgRegion.toLowerCase().includes('ipay88-id')) _amount = _amountPay * 100;
                else if (
                  _type.toLowerCase().includes('ipay88') &&
                  _countryId.toLowerCase() === 'mys' &&
                  !this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
                )
                  _amount = _amountPay.toFixed(2);
                else if (
                  _type.toLowerCase().includes('ipay88') &&
                  _countryId.toLowerCase() === 'mys' &&
                  this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())
                )
                  _amount = 100;
                else _amount = _amountPay * 100;

                let _ipayUrl;
                if (this.selectPaymentMethod === 'ipay88fpx')
                  _ipayUrl = 'https://dvl3.ipay88.com/epayment/entry.asp';
                else {
                  if (_pgRegion.toLowerCase().includes('ipay88-id'))
                    // _pgRegion === 'ipay88-id'
                    _ipayUrl = this.paymentPageURL;
                  //'https://sandbox.ipay88.co.id/epayment/entry.asp';
                  else _ipayUrl = 'https://payment.ipay88.com.my/epayment/entry.asp';
                }
                // https://dvl3.ipay88.com/epayment/entry.asp
                this.localBill = _data.bill;
                if (this.selectPaymentMethod === 'ipay88fpx') {
                  _signature = 'YaYNkBlUnq' + 'M15668' + _data.bill + _amount * 100 + 'MYR';

                  let sha256_signature = this.mg2uUtil.generateHashSignature(
                    this.paymentSignAlgo,
                    _signature,
                    this.ipay88Details.merchantKey
                  ); //sha256(_signature);
                  let sha1_signature = this.mg2uUtil.generateHashSignature('sha1', _signature); //this.sha1.iPay88Signature(_signature);
                  paymentDetailsPage = {
                    MerchantCode: 'M15668',
                    PaymentId: '',
                    RefNo: _data.bill,
                    Amount: _amount,
                    Currency: this.competitionFeeApplicable?.currency || 'MYR',
                    ProdDesc: _description,
                    UserEmail: this.playerInfo?.email,
                    UserName: this.playerInfo?.playerName,
                    UserContact: this.playerInfo?.phone,
                    Remark: _description,
                    SignatureType: this.paymentSignAlgo.toUpperCase(),
                    Signature: sha256_signature,
                    ResponseURL: this.paymentRedirectURL,
                    BackendURL: this.paymentBackendURL,
                  };
                } else {
                  if (
                    _pgRegion.toLowerCase().includes('ipay88-id') &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amount).toFixed(0) +
                      'MYR';
                  else if (
                    _pgRegion.toLowerCase().includes('ipay88-id') &&
                    !this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amountPay * 100).toFixed(0) +
                      'MYR';
                  else if (
                    _pgRegion.toLowerCase() === 'ipay88' &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(100).toFixed(0) +
                      'MYR';
                  else if (
                    _pgRegion.toLowerCase().includes('ipay88-my') &&
                    this.pgDescription.toLowerCase().includes('sandbox')
                  )
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(1).toFixed(0) +
                      'MYR';
                  else
                    _signature =
                      this.ipay88Details.merchantKey +
                      this.ipay88Details.merchantCode +
                      _data.bill +
                      Number(_amount * 100).toFixed(0) +
                      'MYR';

                  let sha256_signature = this.mg2uUtil.generateHashSignature(
                    this.paymentSignAlgo,
                    _signature,
                    this.ipay88Details.merchantKey
                  ); //sha256(_signature);
                  let sha1_signature = this.mg2uUtil.generateHashSignature('sha1', _signature); //this.sha1.iPay88Signature(_signature);
                  let ipay88_signature;
                  ipay88_signature = _pgRegion.toLowerCase().includes('ipay88-id')
                    ? sha1_signature
                    : sha256_signature;
                  let _userEmail;
                  let _userName;
                  let _userContact;

                  paymentDetailsPage = {
                    MerchantCode: this.ipay88Details.merchantCode,
                    PaymentId: '',
                    RefNo: _data.bill,
                    Amount: this.sandboxPayment ? 1 : _amount,
                    Currency: this.competitionFeeApplicable?.currency || 'MYR',
                    // Currency: 'MYR',
                    ProdDesc: _description,
                    UserEmail: this.playerInfo?.email,
                    UserName: this.playerInfo?.playerName,
                    UserContact: this.playerInfo?.phone,
                    Remark: _description,
                    SignatureType: this.paymentSignAlgo.toUpperCase(),
                    Signature: ipay88_signature,
                    ResponseURL: this.paymentRedirectURL,
                    BackendURL: this.paymentBackendURL,
                    PaymentURL: this.paymentPageURL,
                  };
                }

                let _MerchantCode = paymentDetailsPage['MerchantCode'];
                let _PaymentId = paymentDetailsPage['PaymentId'];
                let _RefNo = _data.bill;
                let _Amount = paymentDetailsPage['Amount'];
                let _Currency = paymentDetailsPage['Currency'];
                let _ProdDesc = paymentDetailsPage['ProdDesc'];
                let _UserName = paymentDetailsPage['UserName'];
                let _UserEmail = paymentDetailsPage['UserEmail'];
                let _UserContact = paymentDetailsPage['UserContact'];
                let _Remark = paymentDetailsPage['Remark'];
                let _SignatureType = paymentDetailsPage['SignatureType'];
                let _Signature = paymentDetailsPage['Signature'];
                let _ResponseURL = paymentDetailsPage['ResponseURL'];
                let _BackendURL = paymentDetailsPage['BackendURL'];

                let _params =
                  'MerchantCode=' +
                  _MerchantCode +
                  '&PaymentId=' +
                  _PaymentId +
                  '&RefNo=' +
                  _RefNo +
                  '&Amount=' +
                  _Amount +
                  '&Currency=' +
                  _Currency +
                  '&ProdDesc=' +
                  _ProdDesc +
                  '&UserName=' +
                  _UserName +
                  '&UserEmail=' +
                  _UserEmail +
                  '&UserContact=' +
                  _UserContact +
                  '&Remark=' +
                  _Remark +
                  '&SignatureType=' +
                  _SignatureType +
                  '&Signature=' +
                  _Signature +
                  '&ResponseURL=' +
                  _ResponseURL +
                  '&BackendURL=' +
                  _BackendURL;
                let map;

                var form = document.createElement('form');
                form.target = '_system';
                form.method = 'GET';
                form.action = _url;
                form.style.display = 'none';

                for (var key in paymentDetailsPage) {
                  var input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = key;
                  input.value = paymentDetailsPage[key];
                  form.appendChild(input);
                }

                let _ipay88Header = `<html>
                            <head>
                            </head>`;

                let _ipay88Body =
                  `<body >
    <form id="loginForm" action="` +
                  this.paymentInternalURL +
                  `" method="get">
        <span style="font-size:5vw;">Redirecting to payment page ...</span><br>`;

                for (var key in paymentDetailsPage) {
                  _ipay88Body +=
                    '<input type="hidden" name="' +
                    key +
                    '" value="' +
                    paymentDetailsPage[key] +
                    '">';
                }

                let _ipay88end = `<script type="text/javascript">
        setTimeout("document.getElementById('loginForm').submit()", 500);
        </script>
    </body>

    </html>`;

                let _ipay88content = _ipay88Header + _ipay88Body + _ipay88end;

                let _ipay88ContentUrl =
                  'data:text/html;base64,' + this.mg2uUtil._btoa(_ipay88content);
                let win;
                if (this.platform.is('capacitor')) {
                  this.openWithInAppBrowser(_ipay88ContentUrl, null, 'getBill', data);
                } else {
                  win = window.open('', '_system');
                  document.body.appendChild(form);
                  form.submit();
                  document.body.removeChild(form);
                }

                let winTick = setInterval(() => {
                  if (win && win.closed) {
                    clearInterval(winTick);
                    this.getBill(data.bill, 'ipay88');
                    //
                  }
                }, 500);
              }
            },
            error => {
              if (error) {
                let _error = error;
                if (_error.status === '500' || _error.status === '404') {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                } else if (_error.status === 500 || _error.status === 404) {
                  MessageDisplayUtil.showMessageToast(
                    'Server Unreachable',
                    this.platform,
                    this.toastCtl,
                    3000,
                    'bottom'
                  );
                }
              }
            }
          );
        },
        async error => {
          if (this.loadingCtrl) this.loadingCtrl.dismiss();
          let _msg = error;
          if (_msg.toLowerCase().includes('mobile is invalid')) {
            _msg = 'Mobile phone is invalid. Please update profile and retry payment.';
          } else {
            _msg = 'Something wrong going with payment server. Please try again.';
          }
          MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        }
      );
    });
    setTimeout(() => {
      loder.dismiss().then(() => {});
    }, 300000);
  }

  public openWithInAppBrowser(url: string, target?: string, attribute?: string, data?: any) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL.toLowerCase())) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    } else {
      _iab.on('loadstop').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL)) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    }
    _iab.on('exit').subscribe(
      () => {
        if (attribute === 'getBill') {
          if (this.selectPaymentMethod.toLowerCase().includes('billplz')) {
            this.getBill(data.id, 'billplz');
          } else if (this.selectPaymentMethod.toLowerCase().includes('ipay88'))
            this.getBill(data.bill, 'ipay88');
        }
      },
      err => {}
    );
  }

  public getBill(billId?: string, paymentGateway?: string) {
    this.paymentService.getBill(billId, paymentGateway).subscribe(
      async (data: any) => {
        //this.onNavigateBack();
        if (
          (data.status && data.paid === 'true' && data.status.toLowerCase() === 'p') ||
          (data.state && data.state.toLowerCase() === 'paid' && paymentGateway === 'billplz')
        ) {
          this.paymentMode = false;
          this.paymentStatus = 'Paid';
          let facilityModal = await this.modalCtl.create({
            component: DeleteRoomModalComponent,
            showBackdrop: true,
            backdropDismiss: false,
            mode: 'ios',
            cssClass: this.platform.is('mobile')
              ? 'self-adjustable-modal'
              : 'self-adjustable-modal-desktop',
            componentProps: {
              mode: 'facilitybookingAlert',
              header: 'Payment successful',
              msg: 'Thank you for the payment.<br>Booking receipt will be sent to you via email.',
            },
          });
          await facilityModal.present().then(() => {
            const height = this.platform.height() - 180;
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
          });
          facilityModal.onDidDismiss().then(data => {
            this.backRouting();
          });
          this.paymentFailed = false;
          this.paymentDateTime = null;
        } else if (
          (data.status && data.status.toLowerCase() === 'p') ||
          (data.state && data.state.toLowerCase() === '1' && paymentGateway === 'ipay88')
        ) {
          this.paymentMode = false;
          this.paymentStatus = 'Paid';
          let facilityModal = await this.modalCtl.create({
            component: DeleteRoomModalComponent,
            showBackdrop: true,
            backdropDismiss: false,
            mode: 'ios',
            cssClass: this.platform.is('mobile')
              ? 'self-adjustable-modal'
              : 'self-adjustable-modal-desktop',
            componentProps: {
              mode: 'facilitybookingAlert',
              header: 'Payment successful',
              msg: 'Thank you for the payment.<br>Booking receipt will be sent to you via email.',
            },
          });
          await facilityModal.present().then(() => {
            const height = this.platform.height() - 180;
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
          });
          facilityModal.onDidDismiss().then(data => {
            this.backRouting();
          });
          this.paymentFailed = false;
          this.paymentDateTime = null;
        } else if (
          (data.state && data.state.toLowerCase() === 'due') ||
          (data.status && data.status.toLowerCase() === 'd')
        ) {
          this.paymentStatus = 'Due';
          let facilityModal = await this.modalCtl.create({
            component: DeleteRoomModalComponent,
            showBackdrop: true,
            backdropDismiss: false,
            mode: 'ios',
            cssClass: this.platform.is('mobile')
              ? 'self-adjustable-modal'
              : 'self-adjustable-modal-desktop',
            componentProps: {
              mode: 'facilitybookingAlert',
              header: 'Payment not successful',
              msg: 'Something went wrong with payment. Please refresh and try again in few minutes.',
            },
          });
          await facilityModal.present().then(() => {
            const height = this.platform.height() - 180;
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
          });
          facilityModal.onDidDismiss().then(data => {
            this.backRouting();
          });

          if (this.enablePaymentTimer) {
            this.paymentFailed = true;
            this.paymentDateTime = moment();
          }
        } else {
          if (this.enablePaymentTimer) {
            this.paymentFailed = true;
            this.paymentDateTime = moment();
          }
          // this.onCancelAssignment();
        }
      },
      async error => {
        this.paymentStatus = 'Pending';
        let facilityModal = await this.modalCtl.create({
          component: DeleteRoomModalComponent,
          showBackdrop: true,
          backdropDismiss: false,
          mode: 'ios',
          cssClass: this.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            mode: 'facilitybookingAlert',
            header: 'Ooops',
            msg: 'Something went wrong with payment. Please refresh and try again in few minutes.',
          },
        });
        await facilityModal.present().then(() => {
          const height = this.platform.height() - 180;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        facilityModal.onDidDismiss().then(data => {
          this.backRouting();
        });
        if (this.enablePaymentTimer) {
          this.paymentFailed = true;
          this.paymentDateTime = moment();
        }
      }
    );
  }

  refreshOrderDetails() {}

  onNavigateBack() {
    this.modalCtl.dismiss({
      afterBook: true,
      needRefresh: true,
    });
  }

  isValidPlayerClubBalance() {
    // console.debug("is valid player club acc", this.playerClubAccount)
    if (!this.playerClubAccount) return false;

    if (this.playerClubAccount) {
      if (!this.playerClubAccount.allowCredit)
        if (this.playerClubAccount.balanceAmount > 0) return false;
        else return false;
      else if (this.playerClubAccount.allowCredit) {
        if (this.playerClubAccount.effectiveBalance + this.playerClubAccount.creditLimit > 0)
          return true;
        else return false;
      } else return false;
    }
  }

  bookingOptions: TeeTimeBookingOptions;
  checkClubBookingOption() {
    let _clubId = this.compData?.club?.id;
    let _forDate = moment().format('YYYY-MM-DD');
    this.flightService.getClubBookingOptions(_clubId, _forDate).subscribe(
      (bookOpts: TeeTimeBookingOptions) => {
        if (bookOpts) this.bookingOptions = bookOpts;
      },
      error => {},
      () => {}
    );
  }

  allowClubCedit() {
    return (
      (this.compData?.organizer?.club?.clubId || this.compData?.organizer?.club?.id) ===
      (this.compData?.club?.clubId || this.compData?.club?.id)
    );
  }
}
